// frontend/src/components/InvitationDeleteModal.jsx

import React, { useState } from 'react'
import { useTranslation } from '../i18n'

/**
 * Modal de confirmación para eliminación de invitaciones
 * @param {string} hash - Hash de la invitación
 * @param {function} onConfirm - Función al confirmar eliminación
 * @param {function} onClose - Función al cerrar el modal
 */
export default function InvitationDeleteModal({ hash, onConfirm, onClose }) {
  const [confirmationText, setConfirmationText] = useState('')
  const { _ } = useTranslation()

  const isConfirmed = confirmationText.trim().toUpperCase() === 'ELIMINAR'

  return (
    <div className="modal-backdrop">
      <div className="modal-box w-full max-w-md">
        <h2 className="modal-title">{_('Delete invitation')}</h2>
        <p className="modal-text mb-4">
          {_('To delete this invitation permanently, type')} <strong>ELIMINAR</strong>:
        </p>

        <input
          type="text"
          className="input-inline w-full mb-4"
          placeholder="ELIMINAR"
          value={confirmationText}
          onChange={(e) => setConfirmationText(e.target.value)}
        />

        <div className="flex justify-end gap-2">
          <button className="button-secondary" onClick={onClose}>
            {_('Cancel')}
          </button>
          <button
            className="button-danger"
            disabled={!isConfirmed}
            onClick={() => onConfirm(hash)}
          >
            {_('Delete')}
          </button>
        </div>
      </div>
    </div>
  )
}
